import { router, usePage } from "@inertiajs/react";
import AppLogo from "@/components/app-logo";
import SelectLanguageMenu from "@/components/localization/select-language-menu";
import localization from "@/routes/localization";
import type { SharedData } from "@/types";

export default function AuthHeader() {
  const { name, config } = usePage<SharedData>().props;
  const marketingSiteUrl = config.marketingSiteUrl;

  const setLanguage = (language: string) => {
    if (language !== config.localization.language) {
      router.flushAll();
      router.patch(localization.language.update(), {
        language,
      });
    }
  };

  return (
    <div className="flex w-full items-center justify-between gap-2 p-4">
      <a
        className="relative z-20 flex items-center font-medium text-lg"
        href={marketingSiteUrl}
      >
        <AppLogo name={name} size="md" />
      </a>
      {config.localization.languageOptions && (
        <div className={"w-auto min-w-[180px] bg-background"}>
          <SelectLanguageMenu
            initialValue={config.localization.language}
            onSelect={setLanguage}
          />
        </div>
      )}
    </div>
  );
}
